<template>
  <div>
    <NavBar />
    <full-page :options="options" id="fullpage" ref="fullpage">
      <Home :move-to="api" />
      <About />
      <Features />
      <Contact />
    </full-page>
  </div>
</template>

<script>
// AOS
import AOS from 'aos'
import 'aos/dist/aos.css'
import 'nprogress/nprogress.css'
import 'izitoast/dist/css/iziToast.min.css'

import NavBar from '@/components/NavBar.vue'
import Home from '@/views/Home.vue'
import About from '@/views/About.vue'
import Features from '@/views/Features.vue'
import Contact from '@/views/Contact.vue'

export default {
  data() {
    return {
      options: {
        licenseKey: 'test',
        navigation: true,
        anchors: ['home', 'about', 'features', 'contact'],
        afterResponsive: function() {},
        responsiveWidth: 900,
        scrollBar: true
      },
      api: this.apiMethod
    }
  },

  methods: {
    apiMethod(moveTo) {
      return this.$refs.fullpage.api.moveTo(moveTo)
    }
  },

  created() {
    AOS.init({
      easing: 'ease-out-back',
      duration: 300,
      once: false,
      mirror: true
    })
  },

  mounted: function() {
    this.$nextTick(function() {
      this.$refs.fullpage.api.moveTo(this.$route.path.split('/')[1])
    })
  },
  components: { NavBar, Home, About, Features, Contact }
}
</script>

<style lang="scss">
// custom.scss
@import 'node_modules/bootstrap/scss/bootstrap';
@import 'node_modules/bootstrap-vue/src/index.scss';

$enable-responsive-font-sizes: true;

/* Custom
 * --------------------------------------- */
$orange: #ff7400;
.text-orange {
  color: $orange;
}

$darkblue: #484861;

body {
  font-family: proxima-nova, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1.25rem;
  color: $darkblue;
}

* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.section {
  position: relative;
  text-align: center;

  .illustration {
    transform: scale(1.2);
    width: 50%;
  }
}

@media (min-width: 768px) {
  .section .illustration {
    transform: scale(1.5);
    width: 100%;
  }

  .fsize1 {
    font-size: 3.7rem !important;
  }
  .fsize2 {
    font-size: 3rem;
  }
  .fsize3 {
    font-size: 2rem !important;
  }
}

@media (max-width: 768px) {
  .fp-section,
  .fp-slide,
  .fp-tableCell {
    height: auto !important;
  }
}

.fsize1 {
  font-size: 2.8rem;
}

.fsize2 {
  font-size: 2.3rem;
}

.fsize3 {
  font-size: 1.5rem;
}

.font-weight-thin {
  font-weight: 100 !important;
}

.vcenter {
  min-height: 100vh;
  padding: 130px 0;
}

.fullpage-wrapper {
  overflow: hidden;
}

.zi-0 {
  z-index: 0;
}

.zi-1 {
  z-index: 1;
}

.zi-2 {
  z-index: 2;
}

// Customize button
.btn-outline-success {
  border-radius: 0px;
  color: #fff;
  border-color: $orange;
  background-color: $orange;
}

.btn-outline-success:hover,
.btn-outline-success:disabled {
  color: #fff;
  border-color: $orange;
  background-color: $orange;
}

.btn-outline-success:focus {
  box-shadow: 0 0 0 0.2rem rgba($color: $orange, $alpha: 0.5);
}

.form-control {
  border-radius: 0;
}

.form-control:focus {
  border-color: $orange;
  color: $darkblue;
  box-shadow: 0 0 0 0.2rem rgba($color: $orange, $alpha: 0.2);
}

.fp-right {
  position: fixed;
  z-index: 1;
  width: 20px;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto !important;
  height: 100px;
  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    text-align: center;
    li {
      width: 20px;
      height: 20px;
      text-align: center;
      a {
        display: inline-block;
        white-space: nowrap;
        color: transparent;
        width: 5px;
        height: 5px;
        background-color: $orange;
        overflow: hidden;
        border-radius: 50px;
        vertical-align: middle;
        .fp-sr-only {
          display: none;
        }
        &.active {
          width: 15px;
          height: 15px;
        }
      }
    }
  }
}

#nprogress .bar {
  background-color: $orange;
  height: 3px;
  .peg {
    box-shadow: 0 0 10px $orange, 0 0 5px $orange;
  }
}

#nprogress .spinner-icon {
  border-top-color: $orange;
  border-left-color: $orange;
}
</style>
